export var SearchScope;
(function (SearchScope) {
    SearchScope[SearchScope["Base"] = 0] = "Base";
    SearchScope[SearchScope["OneLevel"] = 1] = "OneLevel";
    SearchScope[SearchScope["Subtree"] = 2] = "Subtree";
})(SearchScope || (SearchScope = {}));
//# sourceMappingURL=search.js.map